import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const StoreContext = createContext(null);
const KEY = "arisha_cart_v1";

export function StoreProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(cart)); }, [cart]);

  const add = useCallback((product, size = "M", qty = 1, color = null) => setCart(c => {
    const colorName = color?.name || "";
    const found = c.find(i => i.id === product.id && i.size === size && (i.color || "") === colorName);
    if (found) return c.map(i => i === found ? { ...i, qty: i.qty + qty } : i);
    return [...c, { ...product, size, qty, color: colorName, image: color?.image || product.image }];
  }), []);
  const update = useCallback((index, delta) => setCart(c => c.map((i, n) => n === index ? { ...i, qty: Math.max(0, i.qty + delta) } : i).filter(i => i.qty)), []);
  const remove = useCallback((index) => setCart(c => c.filter((_, n) => n !== index)), []);
  const clear = useCallback(() => setCart([]), []);

  const value = useMemo(() => {
    const count = cart.reduce((s, i) => s + i.qty, 0);
    const total = cart.reduce((s, i) => s + i.price * i.qty, 0);
    return { cart, add, update, remove, clear, count, total };
  }, [cart, add, update, remove, clear]);

  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
}

export const useStore = () => useContext(StoreContext);
